<div class="main-layout">
  <app-sidebar></app-sidebar>

  <main class="main-layout__content">
    <router-outlet></router-outlet>
  </main>
</div>